<template>
  <div>
    <div class="green-inside">
      <!-- 插件swiper区域 -->
      <div>
        <swiper
          v-if="props.dataArr.length"
          direction="horizontal"
          class="inside-cardBox"
          :slidesPerView="props.dataArr.length >= 1 ? 1 : props.dataArr.length"
          loop
          :autoplay="{ delay: 3000, disableOnInteraction: true }"
          :navigation="false"
          :pagination="{ clickable: true }"
          :scrollbar="{ draggable: true }"
          :space-between="0"
          :centeredSlides="false"
          :modules="modules"
          effect="coverflow"
          @swiper="onSwiper"
          @mouseenter="enter"
          @mouseleave="leave"
          @slideChange="onSlideChange"
        >
          <swiper-slide
            v-for="(item, index) in props.dataArr"
            :key="index"
            class="book-cards"
            @click="swiperSlideClick(item)"
          >
            <div class="book-cards" style="cursor: pointer">
              <!-- <img
                v-if="/^http/.test(item.img_url)"
                class="big-img"
                v-complete:src="item.img_url"
              />
              <img v-else class="big-img" v-complete:src="item.img_url" /> -->

              <img
                v-complete:src="item.image"
                alt=""
                style="
                  width: 343px;
                  height: 201px;
                  display: block;
                  cursor: pointer;
                "
              />

              <p class="box-tit">{{ item.title }}</p>

              <div class="box-tag">
                <el-tag v-if="item.class_stage_text">{{
                  item.class_stage_text
                }}</el-tag>
                <el-tag v-if="item.classes_text">{{
                  item.classes_text
                }}</el-tag>
                <el-tag v-if="item.subject_text">{{
                  item.subject_text
                }}</el-tag>
                <el-tag v-for="(item2, index) in item.tags" :key="index">{{
                  item2.name
                }}</el-tag>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <!-- <el-button
        class="l-btn huibian"
        :icon="ArrowLeft"
        circle
        @click="rightClick"
      ></el-button>
      <el-button
        class="r-btn"
        :icon="ArrowRight"
        circle
        @click="leftClick"
      ></el-button> -->
    </div>
  </div>
</template>

<script setup>
import { toRaw, nextTick, reactive } from "vue";

import { ArrowLeft, ArrowRight } from "@element-plus/icons-vue";
// 引入swiper插件
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper/modules";

// 创建功能模块
let modules = [Autoplay, Navigation, Pagination, Scrollbar, A11y];
//定义swiperNew,目的获取非响应式swiper
let swiperNew = null;
// 事件处理器
const onSwiper = (swiper) => {
  swiperNew = toRaw(swiper); //拿到swiper对象再转换为非响应式
};
//鼠标移入
const enter = () => {
  swiperNew.autoplay.stop();
};
//鼠标移出
const leave = () => {
  swiperNew.autoplay.start();
};
// 点击右箭头
const rightClick = () => {
  nextTick(() => {
    swiperNew.slidePrev();
  });
};
// 点击左箭头
const leftClick = () => {
  nextTick(() => {
    swiperNew.slideNext();
  });
};
// 单元块滑动
const onSlideChange = () => {};

const props = defineProps({
  dataArr: {
    type: Array,
    default: () => {
      return [];
    },
  },

  img_txt: {
    type: String,
    default: "",
  },
});

const mydata = reactive({
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const emits = defineEmits(["itemClick"]);

function swiperSlideClick(item) {
  emits("itemClick", item);
}
</script>

<style scoped lang="scss">
:deep(.myRowBookCards) {
  width: 100% !important;
}
.green-inside {
  width: 343px;
  // height: 300px;
  position: relative;
  margin: 0 auto;
  // border-radius: 8px;
  background: linear-gradient(
    110.52deg,
    rgba(246, 246, 250, 0.4) -1.14%,
    rgba(81, 83, 103, 0) 102.14%
  );
  display: flex;
  flex-direction: column;
  border: 1px solid transparent;
  // border:1px solid blue;
  //////图书卡片组件
  .inside-cardBox {
    display: flex;

    .book-cards {
      width: 343px;
      margin: 0;
      // border:1px solid red;

      > p:nth-of-type(1) {
        width: 100%;
        height: 50px;
        font-size: 16px;
        font-weight: 400;
        color: #000;
        margin-top: 10px;
        margin-bottom: 10px;
        line-height: 25px;
      }
      > p:hover {
        color: #009de0 !important;
      }

      .el-tag {
        background: #f0f5ff;
        color: #333333;
        font-size: 12px;
        border: 1px solid #c5cbce;
        // margin-top: -16px;

        padding: 3px 8px 3px 8px;
        height: 26px;

        margin-left: 0px;
        margin-right: 5px;

        margin-bottom: 5px;
      }
    }
  }
}
:deep(.swiper-wrapper) {
  // width: 365px;
  height: 302px;
}

:deep(
    .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal
  ) {
  display: none;
}

.l-btn {
  position: absolute;
  z-index: 9999;
  color: #ccc;
  font-size: 20px;
  border: 1px solid #ccc;
  width: 25px !important;
  height: 25px !important;
  border-radius: 100%;
  line-height: 25px;
  text-align: center;
  top: 45%;
  left: -50px;
  background: transparent;
}
.r-btn {
  position: absolute;
  z-index: 9999;
  color: #ccc;
  font-size: 20px;
  border: 1px solid #ccc;
  width: 25px !important;
  height: 25px !important;
  border-radius: 100%;
  line-height: 25px;
  text-align: center;
  top: 45%;
  right: -50px;
  background: transparent;
}
</style>
